import React, { useState, useEffect, FC } from 'react';
import './shop-table-row.scss';
import { Checkbox } from 'primereact/checkbox';
import ShopLogo from "assets/side-bar/shop.svg"
import { useDispatch } from 'react-redux';
import { deleteShop, setShopToChangePlan, setShopToEdit } from '../../shopSlices';
import EllipsisMenu from '../ellipsis-menu/ellipsis-menu';
export interface ShopTableRowProps {
    id: string;
    name: string;
    address: number;
    checked: boolean;
    setChecked: (checked: boolean, id: string) => void;
    setShopIdToDelete: Function;
    setWordToConfirm: Function
}

const ShopTableRow:FC<ShopTableRowProps> = ({id, name, address, checked, setChecked, setShopIdToDelete, setWordToConfirm}) => {
    const dispatch: Function = useDispatch();
    
    const handleDeleteShop = () =>{
        setShopIdToDelete(id)
        setWordToConfirm(name)
    }
    const items = [
        { label: 'Edit shop', command: () => dispatch(setShopToEdit(id)) },
        { label: 'Change plan', command: () => dispatch(setShopToChangePlan(id)) }
    ];

    const handleQRCode = () => {
        const url = `https://amorino.qolaig.app/stock-management/ice-cream?shopId=${id}`;
        window.open(`https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(url)}`, '_blank');
    };

    return (
        <div className="shop-table-row">
            <div className="shop-table-row__left">
            <Checkbox onChange={e => setChecked(e.checked,id)} checked={checked}></Checkbox>
            
            <img
                className="shop-table-row__icon"
                src={ShopLogo}
                alt={'Shop'}
              />
            <div className="shop-table-row__info">
                <div className="shop-table-row__info__name">
                    {name}
                </div>
                <div className="shop-table-row__info__address">
                    {address}
                </div>
            </div>
            </div>
            <div className="shop-table-row__buttons">
                <div className="shop-table-row__buttons__qr-btn" onClick={handleQRCode}>
                    QR Code
                </div>
                <div className="shop-table-row__buttons__delete-btn" onClick={()=>handleDeleteShop()}>
                    Delete
                </div>
                <EllipsisMenu items={items} />
            </div>
        </div>
    );
}
         
export default ShopTableRow;